import React from 'react';
import './Partners.css';

import { Heading } from '../../../components';
import { partners, titles } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import { useTranslation } from 'react-i18next';



const Clients = () => {

  const t = useTranslation().t;

  return (
      <section className='partners'>

      {/* Section heading */}
      <Heading title={t(titles.partners)} subTitle={t(titles.subTitlePartners)} />

      <div className='client-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Autoplay]}
          spaceBetween={30}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          breakpoints={{
            0: {
              slidesPerView: 2,
            },
            450: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 4,
            },
            1024: {
              slidesPerView: 5,
            },
          }} 
        >
        {/* Map over the clients array to render each sponsor */}
                  {partners.map((client, index) => {
            return (
              /* Render the client image */
                <SwiperSlide className='client-item' key={index}>
                    <a href={client.link} target="_blank" rel="noopener noreferrer">
                        <img src={client.image} alt='Partner logo' />
                    </a>
                </SwiperSlide>
            )
          })
        }
        </Swiper>
      </div>
    </section>
  );
}

export default Clients;